import type { ReactNode } from 'react';
import styles from './panel.module.css';
import { cx } from './cx';

/** A bordered surface. `centred` is the shape a message takes when it stands in for the player. */
export interface PanelProps {
  readonly children: ReactNode;
  readonly pad?: 'sm' | 'md' | 'lg';
  readonly centred?: boolean;
  readonly className?: string;
  /** `section` when the block has a heading, which is most of them. */
  readonly as?: 'div' | 'section' | 'article';
  readonly ariaLabel?: string;
}

export function Panel({ children, pad = 'md', centred, className, as = 'div', ariaLabel }: PanelProps) {
  const Tag = as;
  return (
    <Tag
      className={cx(
        styles.panel,
        pad === 'sm' && styles.padSm,
        pad === 'lg' && styles.padLg,
        centred && styles.centred,
        className,
      )}
      aria-label={ariaLabel}
    >
      {children}
    </Tag>
  );
}

/**
 * A section label — "CHAPTERS", "RECOMMENDED". A real heading element by default, because that is
 * what it is: skipping the level and styling a `<p>` to look like a label is how a screen reader's
 * document outline loses a section.
 */
export function Eyebrow({
  children,
  as = 'h2',
  className,
}: {
  readonly children: ReactNode;
  readonly as?: 'h2' | 'h3' | 'p';
  readonly className?: string;
}) {
  const Tag = as;
  return <Tag className={cx(styles.eyebrow, className)}>{children}</Tag>;
}
